<template>
    <div class="users">
         <div class="row">
            <div class="col-md-12 text-right">
                <button class="ml-2 btn btn-primary create-project" @click="showModal('new')"><i class="fa fa-plus"></i> New Items</button>

            </div>
        </div>
        <div class="row mt-4">
            <div class="col-md-12">
                
                    <b-table :fields="fields"  striped hover :items="inventoryitems">
                        
                        <template v-slot:head(showid)="">
                            #ID
                        </template>
                        <template v-slot:head(saleprice)="">
                            Sales Price
                        </template>
                        <template v-slot:head(alldetails)="">
                            Actions
                        </template>
                        <template v-slot:cell(saleprice)="data">
                            {{data.item.saleprice}}€
                        </template>

                        <template v-slot:cell(available)="data">
                            <b-badge :variant="data.item.available==true ? 'success':'danger'">{{data.item.available==true ? 'Available':'Unavailable'}}</b-badge>
                            
                        </template>
                        <template v-slot:cell(categoryid)="data">
                            {{getCategories(data.item.categoryid)!=null ? getCategories(data.item.categoryid).name:'NA'}}
                        </template>
                        <template v-slot:cell(alldetails)="data">
                            <b-button variant="primary" size="sm" @click="showModal('edit',data.item)">View</b-button>
                        </template>
                    </b-table>

            </div>
        </div>

        <a-modal
            title="New Item"
            :visible="visible"
            :footer="null"
            @cancel="visible=false;clearValues()"
            >
            
            <div class="row">
                <div class="col-md-12 col-12">
                    <label for="username"><strong>SKU/VCODE</strong> </label>
                    <input v-model="new_inventory_item.sku_vcode" type="text" class="form-control" placeholder="">

                </div>
            </div>
             <div class="row">
                <div class="col-md-6 col-12">
                    <label for="username"><strong>Sales Price in €</strong> </label>
                    <input v-model="new_inventory_item.saleprice" type="number" class="form-control" placeholder="">

                </div>
                <div class="col-md-6 col-12">
                    <label for="username"><strong>Discount Price in €</strong> </label>
                    <input v-model="new_inventory_item.discountprice" type="number" class="form-control" placeholder="">

                </div>

                
            </div>
            <div class="row">
                <div class="col-md-6 col-12">
                    <label for="username"><strong>Portion Size</strong> </label>
                    <input v-model="new_inventory_item.portionsize" type="number" placeholder="eg. 15, as in 15kg" class="form-control" >

                </div>
                <div class="col-md-6 col-12">
                    <label for="username"><strong>Unit</strong> </label>
                    <input v-model="new_inventory_item.unit" type="text" placeholder="kg" class="form-control" >

                </div>
                
            </div>
            

            <div class="row mt-2">
                <div class="col-md-6 col-12">
                        <label for="email"><strong>Availability</strong>: </label>
                        <select v-model="new_inventory_item.available" class="form-control" name="" id="">
                            <option value="true">Available</option>
                            <option value="false">Not Available</option>

                        </select>

                </div>  
                 <div class="col-md-6 col-12">
                        <label for="email"><strong>Parent Category</strong>: </label>
                        <select v-model="new_inventory_item.categoryid"  @change="handleChange" class="form-control" name="" id="">
                            <option v-for="(item,i) in categories" :key="i" :value="item.id">{{item.name}}</option>

                        </select>

                </div>   
                <div v-if="getSubCategories.length>0" class="col-md-12 col-12">
                        <label for="email"><strong>SubCategory</strong>: </label>
                        <select v-model="new_inventory_item.subcategoryid" class="form-control" name="" id="">
                            <option v-for="(item,i) in getSubCategories" :key="i" :value="item.id">{{item.name}}</option>

                        </select>

                </div>               
            </div>
            <div class="row">
                <div class="col-md-12 col-12">
                    <label for="username"><strong>Description</strong> </label>
                    <textarea class="form-control"  v-model="new_inventory_item.description" rows="4" cols="50"/>

                </div>
                
            </div>

           
            <div class="row mt-3">
                <div class="col-md-12">
                    <button class="btn btn-primary btn-block" @click="handleCancel">Create</button>
                </div>
            </div>
        </a-modal>

        <a-modal
            title="Edit Item"
            :visible="editvisible"
            :footer="null"
            @cancel="editvisible=false;clearValues()"
            >
            
            <div class="row">
                <div class="col-md-12 col-12">
                    <label for="username"><strong>SKU/VCODE</strong> </label>
                    <input v-model="new_inventory_item.sku_vcode" type="text" class="form-control" placeholder="">

                </div>
            </div>
             <div class="row">
                <div class="col-md-6 col-12">
                    <label for="username"><strong>Sales Price in €</strong> </label>
                    <input v-model="new_inventory_item.saleprice" type="number" class="form-control" placeholder="">

                </div>
                <div class="col-md-6 col-12">
                    <label for="username"><strong>Discount Price in €</strong> </label>
                    <input v-model="new_inventory_item.discountprice" type="number" class="form-control" placeholder="">

                </div>
                
            </div>
            <div class="row">
                <div class="col-md-6 col-12">
                    <label for="username"><strong>Portion Size</strong> </label>
                    <input v-model="new_inventory_item.portionsize" type="number" placeholder="eg. 15, as in 15kg" class="form-control" >

                </div>
                
                <div class="col-md-6 col-12">
                    <label for="username"><strong>Unit</strong> </label>
                    <input v-model="new_inventory_item.unit" type="text" placeholder="kg" class="form-control" >

                </div>

                
                
            </div>
            

            <div class="row mt-2">
                <div class="col-md-6 col-12">
                        <label for="email"><strong>Availability</strong>: </label>
                        <select v-model="new_inventory_item.available" class="form-control" name="" id="">
                            <option value="true">Available</option>
                            <option value="false">Not Available</option>

                        </select>

                </div>  
                 <div class="col-md-6 col-12">
                        <label for="email"><strong>Parent Category</strong>: </label>
                        <select v-model="new_inventory_item.categoryid" @change="handleChange" class="form-control" name="" id="">
                            <option v-for="(item,i) in categories" :key="i" :value="item.id">{{item.name}}</option>

                        </select>

                </div>  
                <div v-if="getSubCategories.length>0" class="col-md-12 col-12">
                        <label for="email"><strong>SubCategory</strong>: </label>
                        <select v-model="new_inventory_item.subcategoryid" class="form-control" name="" id="">
                            <option v-for="(item,i) in getSubCategories" :key="i" :value="item.id">{{item.name}}</option>

                        </select>

                </div>                
            </div>
            <div class="row">
                <div class="col-md-12 col-12">
                    <label for="username"><strong>Description</strong> </label>
                    <textarea class="form-control"  v-model="new_inventory_item.description" rows="4" cols="50"/>

                </div>
                
            </div>

           
            <div class="row mt-3">
                <div class="col-md-12">
                    <button class="btn btn-primary btn-block" @click="handleCancel"> {{type=='new' ? 'Create':'Update'}}</button>
                </div>
            </div>
        </a-modal>

       
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import moment from 'moment'
export default {
    name: "Users",
    computed:{
        ...mapGetters(['categories','inventoryitems','autoids','subcategories']),
        validationChecker(){
            let arr=['description','sku_vcode','salesprice','unit','categoryid','subcategoryid']
           return arr.filter(item=>this.new_inventory_item[item]=='')

        },
        
      getSubCategories(){
        return this.subcategories.filter(item=>item.categoryid==this.selectedcatid)
      },
    },
    data() {
      return {
          selectedcatid:'',
          new_inventory_item:{
              name:'',
              description:'',
              unit:'',
              saleprice:'',
              sku_vcode:'',
              portionsize:'',
              discountprice:'',
              categoryid:'',
              subcategoryid:'',
              available:true,
              showid:'0',
              created:moment().format("DD-MM-YYYY HH:mm:ss")

          },
          fields:[
              'showid',
              'sku_vcode',
              'saleprice',
              'available',
              'categoryid',
              'description',
              'alldetails'
              


          ],
        visible: false,
        editvisible:false,
        type:''

       
      };
    },

    methods: {
      handleChange(e){
        this.selectedcatid=e.target.value

      },
      getCategories(id){
        return this.categories.find(item=>item.id==id)
      },
      showModal(type,item) {
            if(type=='edit') {
                this.type=type
                this.editvisible = true;
                this.new_inventory_item=item
                this.selectedcatid=item.categoryid
                
            }
            else {
                this.visible = true;
                this.type=type
            }
      },
      clearValues(){
          this.new_inventory_item={
              description:'',
              unit:'',
              saleprice:'',
              sku_vcode:'',
              portionsize:'',
              discountprice:'',
              categoryid:'',
              available:true,
              created:''


            }
        this.visible = false; 
        this.editvisible = false;
        this.selectedcatid=''

      },
      handleCancel(e) {
        //   console.log( )
        this.new_inventory_item.created=moment().format("DD-MM-YYYY HH:mm:ss")
          if(this.validationChecker.length<1) {
              if(this.type=='new'){
                this.new_inventory_item.showid=this.autoids.items+1
                this.$store.dispatch("updateAutoId",{items:this.autoids.items+1})
                this.$store.dispatch("createInventoryItem",this.new_inventory_item)
              }
              else{

                this.$store.dispatch("updateInventoryItem",this.new_inventory_item)

              }
            this.clearValues()

          }
          else{
            this.$store.commit("setNotifications",{message:'Description  <br> skucode <br> sales price <br> unit <br> Category/Sub Category are mandatory',type:'error'})

          }
      },
    
    }
}
</script>
